import UUID from 'util/UUID';
import { ContainerType, Container } from 'shared/models';

export type Props = {
    id?: string;
    top: number;
    left: number;
    width: number;
    height: number;
    displayName: string;
    type: ContainerType;
    backgroundColor?: string;
    assetOrder?: string[];
    visible?: boolean;
    locked?: boolean;
    borderThickness?: number;
    borderColor?: string;
};

export const makeNewContainer = ({ id, top, left, width, height, displayName, assetOrder = [], type, backgroundColor = '', borderThickness = 0, borderColor = '', visible = true, locked = false }: Props): Container => {
    return {
        id: id || UUID.generate(),
        displayName,
        left,
        top,
        width,
        height,
        assetOrder,
        borderColor,
        borderThickness,
        backgroundColor,
        opacity: 100,
        transition: 'fade',
        type,
        locked,
        visible,
    };
};
